import { connect } from 'react-redux';
import FaqDashboard from '../../../components/faqDashboard/FaqDashboard';
import { 
  getFaqDashboardSummary, 
  setFaqDaysFilter 
} from 'core/slices/faqDashboard';
import { summary, profile, sucursal_id, daysFilter, faqDashboardLoading } from 'core/selectors';

export default connect(
  state => ({
    summary: summary(state),
    profile: profile(state),
    sucursal_id: sucursal_id(state),
    daysFilter: daysFilter(state),
    loading: faqDashboardLoading(state),
  }),
  { getFaqDashboardSummary, setFaqDaysFilter }
)(FaqDashboard);        